/**
 * 请求工厂：按「服务 + 请求体形态 + 认证方式」生成请求对象
 *
 * 和 mall_h5 的 createRequest 一样，把「具体请求怎么写」抽成配置，
 * 但保留 PC 原有的服务对象形态（get/post/put/delete），
 * 这样 src/service/** 里的调用方一行都不用改。
 *
 * 用法（加新域名时照抄）：
 *   import createRequest from './request/createRequest';
 *   // 主接口：信封 + token 在信封里
 *   export default createRequest('main', { envelope: 'header-body' });
 *   // op 接口：参数平铺 + Authorization: Bearer
 *   export default createRequest('op', { envelope: 'flat', auth: 'bearer' });
 *
 * @param {string} service 服务名（见 src/config/api.js）
 * @param {object} options
 *  - envelope 请求体形态：'header-body' | 'flat'，默认 flat
 *  - auth     'bearer'（token 放请求头）| 'token'（token 放信封/参数），默认 token
 *  - login    是否需要登录态，默认 true
 *  - validate 是否按类型过滤无效值：不传 = 按出口默认（校验）；false = 该服务全部不校验
 *  - handler  响应处理函数，默认 checkStatus（成功给 data，失败给 {status, message}）
 * @returns {object} { get, post, put, delete, request }
 *   api.get/post/put/delete(url, params, requestOptions)
 *     requestOptions 是本次请求的额外选项（如 { validate: false } / { timeout: 8000 }），
 *     不传时按服务默认 —— 用来精确控制「某个接口是否校验值有效性」
 */
import { checkStatus, httpRequest, ENVELOPE } from './createHttpService';

const ACTIONS = ['get', 'post', 'put', 'delete'];

export default function createRequest(service, options = {}) {
  const {
    envelope = ENVELOPE.FLAT,
    auth = 'token',
    login = true,
    validate,
    handler = checkStatus
  } = options;

  const api = {};

  ACTIONS.forEach(action => {
    api[action] = (url, params = {}, requestOptions = {}) =>
      httpRequest({
        service,
        method: action,
        url,
        params,
        envelope,
        auth,
        login,
        validate,
        ...requestOptions
      }).then(handler);
  });

  // 需要额外配置时用（如 timeout、本次换信封、本次不做 handler）
  api.request = config =>
    httpRequest({ service, envelope, auth, login, validate, ...config }).then(
      handler
    );

  return api;
}
